import React from 'react';
import PropTypes from 'prop-types';

// The Twine knot mark, same paths as components/Header/Main/logo.svg.
const TwineMark = ({ size = 48, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 284 320"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M59.7,195.8c-19.2-19.2-19.7-50.2-1.4-70l2.8-2.8c17.6-16.4,45-16.4,62.5,0.2l51.8,51.8c7,7,18.4,7,25.4,0l0,0 c6.9-6.9,7-18.1,0.2-25.1l-55-55c-15.7-15.7-15.7-41.2,0-56.9l0,0l5.4-5.4c6-6,6-15.8,0-21.8l0,0c-5.9-5.9-15.2-6-21.3-0.5l0,0 l-0.5,0.5l0,0L97,43.5l0,0L34.5,106c-29.7,29.7-29.7,78.4,0,108.1l52,52c6,6,15.8,6,21.8,0s6-15.8,0-21.8L59.7,195.8z" />
    <path d="M245.6,107.2L226.5,88l-32.8-32.8c-6-6-15.8-6-21.8,0s-6,15.8,0,21.8l48.4,48.5c17.7,17.6,19.5,45.3,5.4,65 c-1.6,2.2-3.3,4.4-5.3,6.4l0,0c-18,18-47.2,18-65.2,0l0,0l-49.4-49.4c-7-7-18.4-7-25.4,0c-6.9,6.9-7,18.1-0.2,25.1l0,0l52.8,52.8 l0,0c16.3,16.3,16.3,42.8,0,59.1l-4.3,4.3c-6,6-6,15.8,0,21.8l0,0c5.9,5.9,15.5,6,21.6,0.2l0,0l0.2-0.2l32.8-32.8l0,0l62.5-62.5 C275.3,185.5,275.3,136.9,245.6,107.2z" />
  </svg>
);

TwineMark.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default TwineMark;
